import { Pipe, PipeTransform } from '@angular/core';
import { ProgressStatusCode } from '../security-deposit/applications/models/applications.model';

@Pipe({
  standalone: false, name: 'progressStatus' })
export class ProgressStatusPipe implements PipeTransform {
  private types: { [key: string]: string } = {};

  constructor() {
    this.types[ProgressStatusCode.notInvitedYet] = 'Not invited yet';
    this.types[ProgressStatusCode.invited] = 'Invited';
    this.types[ProgressStatusCode.registered] = 'Registered';
    this.types[ProgressStatusCode.inProgress] = 'In progress';
    this.types[ProgressStatusCode.completed] = 'Completed';
    this.types[ProgressStatusCode.sdPendingPmtDetails] = 'Payment details for SD are pending';
    this.types[ProgressStatusCode.bondPendingPmtDetails] = 'Payment details for Bond are pending';
    this.types[ProgressStatusCode.pendingSignature] = 'Agreement signature is pending';
    this.types[ProgressStatusCode.pendingApproval] = 'Pending approval';
    this.types[ProgressStatusCode.bondSdFundReady] = 'Bond SD is ready for funding';
    this.types[ProgressStatusCode.sdFunded] = 'SD is funded';
    this.types[ProgressStatusCode.bondSdFunded] = 'Bond SD is funded';
    this.types[ProgressStatusCode.sdDeclined] = 'SD is declined';
    this.types[ProgressStatusCode.declined] = 'Declined';
    this.types[ProgressStatusCode.bondSdDeclined] = 'Bond SD is declined';
    this.types[ProgressStatusCode.closedNotInterested] = 'Closed — Resident not interested';
    this.types[ProgressStatusCode.closedDifferentApartment] = 'Closed — Resident took a different apartment';
    this.types[ProgressStatusCode.closedNotResponding] = 'Closed — Resident not responding';
    this.types[ProgressStatusCode.bondApproved] = 'Approved';
    this.types[ProgressStatusCode.closedNa] = 'Closed — NA';
    this.types[ProgressStatusCode.closedRefunded] = 'Closed — Resident was refunded';
    this.types[ProgressStatusCode.leaseEnded] = 'Lease ended';
    this.types[ProgressStatusCode.contractEnded] = 'Contract ended';
    this.types[ProgressStatusCode.closedDeclinedByLandlord] = 'Closed — Declined by the landlord';
    this.types[ProgressStatusCode.closedNotAffordable] = 'Closed — Application not affordable';
    this.types[ProgressStatusCode.fullSdPendingPmtDetails] = 'Payment details for Full SD are pending';
    this.types[ProgressStatusCode.pendingSdDeployment] = 'SD deployment is pending';
    this.types[ProgressStatusCode.deployingFunds] = 'Deploying funds';
    this.types[ProgressStatusCode.pendingTenantPlanReview] = 'Resident plan review is pending';
    this.types[ProgressStatusCode.withdrawingTenantFunds] = 'Withdrawing resident funds';
    this.types[ProgressStatusCode.closedArchivedByLandlord] = 'Closed — Archived by the landlord';
    this.types[ProgressStatusCode.certificatePendingPmtDetails] = 'Certificate payment details are pending';
    this.types[ProgressStatusCode.rentCollection] = 'Rent collection';
  }

  transform(value: ProgressStatusCode): string {
    return this.types[value] ?? 'Unknown';
  }
}
